"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var financeSummaryBreakdownWidgetStyles_1 = require("./financeSummaryBreakdownWidgetStyles");
var usePlatformConfig_1 = require("../../../../../../common/react/usePlatformConfig");
var usePriceFormatter_1 = require("../../../../../../../../common/react/usePriceFormatter");
var useWidgetContext_1 = require("../../../../../../common/react/useWidgetContext");
var CurrencyContext_1 = require("../../../../../common/context/CurrencyContext");
var FinanceRowValue = function (_a) {
    var _b;
    var row = _a.row;
    var _c, _d;
    var isChangeCurrency = react_1.useContext(CurrencyContext_1.default).isChangeCurrency;
    var _e = useWidgetContext_1.default().configuration.dimensions, language = _e.language, country = _e.country;
    var _f = usePlatformConfig_1.default().platformConfig.priceDisplay, primaryCurrency = _f.primaryOptions.currency, secondaryCurrency = _f.secondaryOptions.currency, finance = _f.finance;
    var priceFormatter = usePriceFormatter_1.default({
        currency: isChangeCurrency ? secondaryCurrency : primaryCurrency,
        dimensions: {
            language: language,
            country: country,
        },
        decimals: (_d = (_c = finance) === null || _c === void 0 ? void 0 : _c.decimalScale, (_d !== null && _d !== void 0 ? _d : 0)),
    });
    var value = row.value, suffix = row.suffix, shouldBeFormatted = row.shouldBeFormatted;
    var styles = financeSummaryBreakdownWidgetStyles_1.default();
    var formattedValue = shouldBeFormatted ? priceFormatter.format(Number(value)) : value;
    return (<core_1.Typography className={clsx_1.default([styles.elementContent, (_b = {}, _b[styles.highlighted] = row.highlighted, _b)])}>
      {formattedValue}
      {suffix && <Translation_1.default id={suffix}/>}
    </core_1.Typography>);
};
exports.default = FinanceRowValue;
